import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import styled from "styled-components";

import { AccountContext } from "../../provider";
import ToastService from "../../service/toast-service";
import AuthService from "../../service/auth";
import ConnectGoogle from "./connect-google";
import ConnectSpotify from "./connect-spotify";
import { Box, Row, Col, Img, Text, Button } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { faExpand, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { avatar, googleLogo, spotifyLogo } from "../../theme/image";
import redirect from "../../connectors/redirect";

const Wrapper = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const ProfileWrapper = styled(Col)`
  width: 40%;
  height: 70%;
  /* min-width: 900px;
  min-height: 700px; */
  padding-left: 3%;
  padding-right: 3%;
  justify-content: space-around;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.color.GRAY_1};
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 1);
  &:hover {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 1);
  }
`;

const Head = styled(Row)`
  width: 100%;
  height: 38%;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
`;

const Details = styled(Col)`
  height: 70%;
  margin-left: 4%;
`;

export default () => {
  const [userInfo] = useContext(AccountContext);
  const [redirectTo, setRedirect] = useState("");
  const { isLoggedIn, profile } = userInfo;
  const { spotifyConnected, googleConnected, username, name, imageUrl } =
    profile || {};

  const fetchProfile = async () => {
    const newProfile = await AuthService.profile();
    if (!newProfile) ToastService.infoToast("You are not logged in");
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (redirectTo) return <Redirect push to={redirectTo} />;
  return (
    <Wrapper>
      <ProfileWrapper>
        <Head>
          <Img height="80%" round={imageUrl && true} src={imageUrl || avatar} />
          <Details>
            <Row>
              <Text
                fontSize="18px"
                color={Theme.color.GRAY_1}
                fontFamily={Theme.fontFamily.recursive}
                fontWeight="600"
              >{`USERNAME : `}</Text>
              <Text
                fontSize="18px"
                color={Theme.color.GRAY_0}
                fontFamily={Theme.fontFamily.recursive}
                fontWeight="600"
              >
                {isLoggedIn ? username : "----/----"}
              </Text>
            </Row>
            <Row style={{ marginTop: "8px" }}>
              <Text
                fontSize="18px"
                color={Theme.color.GRAY_1}
                fontFamily={Theme.fontFamily.recursive}
                fontWeight="600"
              >{`NAME : `}</Text>
              <Text
                fontSize="18px"
                color={Theme.color.GRAY_0}
                fontFamily={Theme.fontFamily.recursive}
                fontWeight="600"
              >
                {isLoggedIn ? name : "----/----"}
              </Text>
            </Row>
            <Button
              width="90%"
              height="28px"
              buttonTextColor={Theme.textColor.light}
              buttonBackground={Theme.color.RED_6}
              buttonName={isLoggedIn ? "Logout" : "Login"}
              buttonIcon={faSignOutAlt}
              buttonFontSize="14px"
              borderRadius={5}
              marginTop="8px"
              onClick={() => {
                if (isLoggedIn) AuthService.logout();
                else setRedirect("/auth");
              }}
            />
          </Details>
        </Head>
        <ConnectSpotify connected={spotifyConnected} username={username} />
        <ConnectGoogle connected={googleConnected} />
      </ProfileWrapper>
    </Wrapper>
  );
};
